import React from 'react'
import { Span, TextInput, Button } from '@pandiafi/design-system'
import { Formik, Field, FieldProps, Form } from 'formik'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Text } from '@pandiafi/components'

import {
  SetVerificationCodeEmailRequest,
  setVerificationCodeEmailRequestSchema,
} from '../../../../common/validations'
import routePath from '../../../router/routePath'
import { TextLink } from './TextLink'

import FormFieldWrapper from 'components/FormField'
import { validateFormValues } from 'utils'

export const VerifyEmailForm: React.FC<{
  onSuccess: (email: string) => void
  onCancel: () => void
}> = ({ onCancel, onSuccess }) => {
  const navigate = useNavigate()
  const { t } = useTranslation(['managePassword', 'registration'])
  const handleValidate = (formValues: SetVerificationCodeEmailRequest) => {
    const validationErrors = validateFormValues(
      formValues,
      setVerificationCodeEmailRequestSchema
    )

    return validationErrors
  }

  const handleSubmit = (values: SetVerificationCodeEmailRequest) => {
    onSuccess(values.email)
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      validate={handleValidate}
      initialValues={{
        email: '',
      }}
      validateOnMount
    >
      {({ isSubmitting, isValid, setFieldValue }) => {
        return (
          <Form className="flex flex-col gap-5">
            <Text size="l" weight="medium" element="h3">
              {t('managePassword:passwordForgottenHeader')}
            </Text>
            <Span light>
              {t('managePassword:forgotPasswordViewInputEmailDescription')}
            </Span>
            <Span light>
              {t('managePassword:resetUser.text')}{' '}
              <TextLink
                text={t('managePassword:resetUser.resetLinkText')}
                onClick={() => {
                  navigate({
                    pathname: routePath.registerAuth,
                    search: createSearchParams({
                      resetOldUser: 'true',
                      provider: 'telia',
                    }).toString(),
                  })
                }}
              />
              .
            </Span>
            <Field name="email">
              {({
                field,
                meta,
              }: FieldProps<SetVerificationCodeEmailRequest['email']>) => (
                <FormFieldWrapper
                  name={field.name}
                  meta={meta}
                  label={t('registration:confirmEmailLabel')}
                  required
                >
                  <TextInput
                    {...field}
                    type="email"
                    name={field.name}
                    onChange={(event) => {
                      const lowercaseValue = event.target.value.toLowerCase()
                      setFieldValue('email', lowercaseValue)
                    }}
                  />
                </FormFieldWrapper>
              )}
            </Field>

            <Button
              loading={isSubmitting}
              disabled={!isValid || isSubmitting}
              type="submit"
            >
              {t('managePassword:sendForgotPasswordEmailButtonText')}
            </Button>

            <Button type="button" variant="cancel" onClick={onCancel}>
              {t('registration:confirmEmaiCancel')}
            </Button>
          </Form>
        )
      }}
    </Formik>
  )
}
